import { Navigate } from "react-router-dom";
import AuthService from "../core/services/auth";

function GuestRoute({ children }) {
    const isAuthenticated = AuthService.isUserLoggedIn();
    return !isAuthenticated ? children : <Navigate to="/dashboard" />;
}

export { GuestRoute };
